import { useApprovalWorkflowValidate } from '../useApprovalWorkflowValidate/useApprovalWorkflowValidate'
import { usePermissionValidate } from '../usePermissionValidate/usePermissionValidate'
import { useTransferTypeValidate } from '../useTransferTypeValidate/useTransferTypeValidate'

export const useWalletApprovalPolicyValidate = () => {
  const permissionValidate = usePermissionValidate()
  const approvalWorkflowValidate = useApprovalWorkflowValidate()
  const transferTypeValidate = useTransferTypeValidate()

  const isValid =
    permissionValidate.isValid &&
    (approvalWorkflowValidate.isOptional || approvalWorkflowValidate.isValid) &&
    transferTypeValidate.isValid

  const enableSaveExit =
    permissionValidate.enableSaveExit &&
    approvalWorkflowValidate.enableSaveExit &&
    transferTypeValidate.enableSaveExit

  const isAllStepsEmpty =
    permissionValidate.isEmpty &&
    approvalWorkflowValidate.isEmpty &&
    transferTypeValidate.isEmpty

  return {
    isValid,
    enableSaveExit,
    allStepsEmpty: isAllStepsEmpty,
  }
}
